import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { useI18n } from '@/hooks/useI18n';
import {
    createItineraryPaymentLink,
    itineraryPaymentErrorKey,
} from '@/services/itinerary-payment.service';

/**
 * Genera il link Stripe e ci porta sopra il cliente.
 *
 * Il link non viene memorizzato: e' monouso per definizione e un link generato dieci
 * minuti fa potrebbe riferirsi a una rata che nel frattempo l'advisor ha incassato a
 * mano. Si crea al click e si consuma subito.
 */
export const useCreateItineraryPaymentLink = () => {
    const { toast } = useToast();
    const { t } = useI18n();

    return useMutation({
        mutationFn: (params: {
            itineraryId: string;
            installmentId?: string;
            customerEmail?: string | null;
            legalAccepted?: boolean;
        }) =>
            createItineraryPaymentLink(params),
        onSuccess: (url) => {
            // Stessa scheda: il ritorno da Stripe deve poter riportare il cliente qui, e
            // i popup blocker mangiano le window.open non immediate.
            window.location.href = url;
        },
        onError: (error) => {
            toast({ title: t(itineraryPaymentErrorKey(error)), variant: 'destructive' });
        },
    });
};
